import { createGrid, themeQuartz } from 'ag-grid-community'
import { makeColumnDefs } from './make-column-defs.js'
import { makeRows } from './make-rows.js'

export function showTableTrackings (browserAppAccount) {
  console.log('showTableTrackings')

  const entitiesTrackings = browserAppAccount.data.trackings

  const rows = makeRows(entitiesTrackings, browserAppAccount)
  console.log('rows', rows)

  const columnDefs = makeColumnDefs(entitiesTrackings)
  console.log('columnDefs', columnDefs)

  const gridOptions = {
    rowData: rows,
    columnDefs,
    defaultColDef: {
      filter: true,
      floatingFilter: true
    },
    autoSizeStrategy: {
      type: 'fitCellContents'
    },
    getRowId: (cellParams) => cellParams.data.id,
    onCellClicked: function (cellParams) {
      console.log('onCellClicked', cellParams)
    },
    theme: themeQuartz
  }

  const containerId = 'trackingsGrid'
  const gridContainerElement = document.getElementById(containerId)
  console.log('gridContainerElement', gridContainerElement)
  const gridApi = createGrid(gridContainerElement, gridOptions)
  console.log('grid created', gridApi)
}
